export default __webpack_public_path__ + "static/media/3-small.b9366efb.png";